import mdsRequire from 'dojo/require';
﻿import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { SelectEntityDialog } from '../../moreCore/_loadingHelpers/SelectEntityDialog';
/**
 * Interface für das Widget das die Vererbungslinie angibt um die korrekten Typings zu setzen
 */
type _GlobalSelectEntityDialogsMixin__mdsbase = InstanceType<typeof _WidgetBaseSP>;
interface _GlobalSelectEntityDialogsMixin extends _GlobalSelectEntityDialogsMixin__mdsbase { }
export default function _GlobalSelectEntityDialogsMixin(__Base: any) {
  const __C = 
class _GlobalSelectEntityDialogsMixin extends __Base {

    private _loadedSEDconfig: { data: any, mode: string };
    selectEntityDlg: MdsLax<InstanceType<typeof SelectEntityDialog<any>>>;

    protected SEDconfigCallfunction: string;

    private initialSearchValue: string;

    /**
     * ALIAS für loadSelectEntityDialog.
     * Dialog öffnen und Konfiguration laden, falls noch nicht vorhanden
     * @param evt Klickevent
     * @param identifierName (willkürlicher) eindeutiger Name, anhand dessen das Backend entscheidet, welche Konfiguration zusammengestellt gehört
     * @param onCallback_Dlg Callback des SelectEntityDialogs. Aufrufparameter: identifierName, Respone von SED (Array mit Stringvalues, Array mit Items)
     * @param onCreateNew_Callback Callback, das bei Klick auf "neu" im Dialog ausgeführt wird. (wenn leer, wird kein Neu-Button angezeigt)
     * @param additionalData Weitere Requestdaten, die dem SelectEntityDialog zur Ausführung seiner Suche ergänzt werden
     */
    protected openSelectEntityDialog(
        evt: MouseEvent,
        identifierName: string,
        onCallback_Dlg: Function,
        onCreateNew_Callback: Function = null,
        additionalData: Object = null,
        forceReload?: boolean,
        intialSearchValue?: string
    ) {
        this.loadSelectEntityDialog(evt, identifierName, onCallback_Dlg, onCreateNew_Callback, additionalData, forceReload, intialSearchValue);
    }

    /** ALIAS für loadSelectEntityDialog.
     * Dialog öffnen und Konfiguration laden, falls noch nicht vorhanden
     * @param evt Klickevent
     * @param identifierName (willkürlicher) eindeutiger Name, anhand dessen das Backend entscheidet, welche Konfiguration zusammengestellt gehört
     * @param onCallback_Dlg Callback des SelectEntityDialogs. Aufrufparameter: identifierName, Respone von SED (Array mit Stringvalues, Array mit Items)
     * @param onCreateNew_Callback Callback, das bei Klick auf "neu" im Dialog ausgeführt wird. (wenn leer, wird kein Neu-Button angezeigt)
     * @param additionalData Weitere Requestdaten, die dem SelectEntityDialog zur Ausführung seiner Suche ergänzt werden
     */
    protected showSelectEntityDialog(
        evt: MouseEvent,
        identifierName: string,
        onCallback_Dlg: Function,
        onCreateNew_Callback: Function = null,
        additionalData: Object = null,
        forceReload?: boolean
    ) {
        this.loadSelectEntityDialog(evt, identifierName, onCallback_Dlg, onCreateNew_Callback, additionalData, forceReload);
    }

    /**
     * Dialog öffnen und Konfiguration laden, falls noch nicht vorhanden
     * @param evt Klickevent
     * @param identifierName (willkürlicher) eindeutiger Name, anhand dessen das Backend entscheidet, welche Konfiguration zusammengestellt gehört
     * @param onCallback_Dlg Callback des SelectEntityDialogs. Aufrufparameter: identifierName, Respone von SED (Array mit Stringvalues, Array mit Items)
     * @param onCreateNew_Callback Callback, das bei Klick auf "neu" im Dialog ausgeführt wird. (wenn leer, wird kein Neu-Button angezeigt)
     * @param additionalData Weitere Requestdaten, die dem SelectEntityDialog zur Ausführung seiner Suche ergänzt werden
     */
    protected loadSelectEntityDialog(
        evt: MouseEvent,
        identifierName: string,
        onCallback_Dlg: Function,
        onCreateNew_Callback: Function = null,
        additionalData: Object = null,
        forceReload?: boolean,
        initialSearchValue?: string
    ) {
        this.initialSearchValue = initialSearchValue;

        if (!this.SEDconfigCallfunction) {
            alert(this.id + ": no callfunction (API) for SED configuration set!");
            return;
        }
        if (forceReload == true) this.invalidateLoadedSelectEntityDialogConfig(identifierName);
        let hourglassNode = evt?.target instanceof HTMLElement ? evt.target : null;
        if (hourglassNode) {
            let cssBefore = getComputedStyle(hourglassNode, ":before");
            let cssAfter = getComputedStyle(hourglassNode, ":after");
            let iterations = 0;
            while (cssBefore.content != "none" || cssAfter.content != "none") {

                hourglassNode = hourglassNode.parentElement;
                iterations++;
                if (hourglassNode) {

                    cssBefore = getComputedStyle(hourglassNode, ":before");
                    cssAfter = getComputedStyle(hourglassNode, ":after");
                } else {
                    break;
                }

                if (iterations > 3) break;
            }
        }

        if (this._loadedSEDconfig && this._loadedSEDconfig.mode == identifierName) {
            this._onGetDlgConfig(onCallback_Dlg, onCreateNew_Callback, additionalData, identifierName, hourglassNode, this._loadedSEDconfig.data);
            return;
        }



        let data = { "mode": identifierName };

        if (additionalData) {
            try {
                for (let key in additionalData) {
                    data[key] = additionalData[key];
                }
            } catch {

            }
        }

        this.hourGlassStart(hourglassNode);
        this.RequestManager.callfunction(this.SEDconfigCallfunction, data,
            lang.hitch(this, this._onGetDlgConfig, onCallback_Dlg, onCreateNew_Callback, additionalData, identifierName, hourglassNode),
            lang.hitch(this, this._onGetDlgConfigError, hourglassNode),
            false // sync
        );
    }

    protected invalidateLoadedSelectEntityDialogConfig(identifierName?: string) {
        if (this._loadedSEDconfig && this._loadedSEDconfig.mode == identifierName) {
            this._loadedSEDconfig = null;
        }
        else if (this._loadedSEDconfig && !identifierName) {
            this._loadedSEDconfig = null;
        }
    }

    private _onGetDlgConfig(onCallback_Dlg, onCreateNew_Callback, additionalData, mode: string, hourglassNode: HTMLElement, resultConfig) {
        let SelectEntityDialogClass: any = mdsRequire("moreCore/UI/SelectEntityDialog/SelectEntityDialog");
        this.selectEntityDlg = (new SelectEntityDialogClass()) as MdsLax<InstanceType<typeof SelectEntityDialog<any>>>; //NOTE - dynamic require wegen loop import
        this.selectEntityDlg.on("show", lang.hitch(this, this.onDlgShow));
        let dlg = this.selectEntityDlg;
        let callbackCreateNew = null;
        dlg.on("close", lang.hitch(this, this._onClose_SED, onCallback_Dlg, mode));
        if (onCreateNew_Callback) {
            callbackCreateNew = lang.hitch(this, onCreateNew_Callback, dlg);
        }

        this._loadedSEDconfig = { data: resultConfig, mode: mode };

        dlg.setConfiguration(
            resultConfig,
            lang.hitch(this, onCallback_Dlg, mode),
            callbackCreateNew);
        //dlg.setValues(this.previousSEDvalue);
        dlg.addGlobalRequestProperty("mode", mode);


        // datum und aktuelle Buchung mitgeben
        if (additionalData) {
            for (let key in additionalData as Object) {
                dlg.addGlobalRequestProperty(key, additionalData[key]);
            }
        }

        dlg.show(this.initialSearchValue);
        this.hourGlassEnd(hourglassNode);
    }


    protected onDlgShow() {

    }

    private _onClose_SED(callback: Function, mode: string) {
        // hierher kommen wir, wenn der Dlg ohne Ergebnis beendet wurde (Abbruch oder schließen)
        if (callback) {
            callback(mode, null, null);
        }
    }
    private _onGetDlgConfigError(hourglassNode: HTMLElement, error: more.requestErrorMessage) {
        console.log("error", error)
        alert(error.Message);

        this.hourGlassEnd(hourglassNode);
    }

    postCreate() {
        let self: any = this;
        super.postCreate.apply(this, arguments as any);

        this.useStandbyManager = true;
    }


    postMixInProperties(): void {
        let self: any = this;
        super.postMixInProperties.apply(this, arguments as any);
    }

}

;
Object.assign(__C.prototype, {
  SEDconfigCallfunction: null,
  initialSearchValue: "",
  declaredClass: '_GlobalSelectEntityDialogsMixin',
});
  return __C;
}
Object.assign(_GlobalSelectEntityDialogsMixin, { __mdsMixinFactory: true, __mdsSpineBases: [_WidgetBaseSP] });
